// It's there, I promise.
export const ZERO_WIDTH_SPACE = "​";
